export default "__VITE_ASSET__BCtCYTL3__"